//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FastSearch from "@/0/components/comForm/comFormFastSearch";
import QueryForm from "@/0/components/comForm/comIndexQueryForm.vue";
import FormOperateList from "@/0/components/comForm/comFormOperateList.vue";
import FormTable from "@/0/components/comForm/comIndexFormTable.vue";

import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  name: "",
  components: {
    "fast-search": FastSearch,
    "query-form": QueryForm,
    "operate-list": FormOperateList,
    "form-table": FormTable
  },
  props: ["config"],
  data() {
    return {
      isFormInit: false,
      formItem: null,
      postData: {},
      btnConfig: {
        list: [
          // {
          //   text: "新增",
          //   type: "primary",
          //   action: () => {
          //     var url = "/Tpl/Template/Create";
          //     this.$path.to(url);
          //   }
          // },
          { text: "返回", type: "warn", action: () => this.$router.go(-1) }
        ]
      },
      search_info: {
        text: "请输入搜索内容"
      },
      sliderConfig: {
        isShow: false,
        formConfig: {
          list: [
            {
              ControlId: "SystemCode",
              ControlType: "Input",
              ControlValue: "",
              ExtConfig: null,
              IsCheckStrictly: false,
              IsFilter: false,
              IsReadonly: false,
              IsRequired: false,
              LabelName: "系统编码",
              OpenId: "6756d7f63c16470693d66fd1a9d27dad",
              PlaceHolder: "系统编码",
              RelateControlList: null,
              SelectDataList: null
            },
            {
              ControlType: "Input",
              LabelName: "手机号",
              PlaceHolder: "请输入手机号",
              no_arrow: true
            },
            {
              ControlType: "Input",
              LabelName: "订单号",
              PlaceHolder: "请输入订单号",
              no_arrow: true
            },
            {
              ControlType: "Input",
              LabelName: "人员",
              PlaceHolder: "请输入人员",
              no_arrow: true
            },
            {
              ControlType: "date",
              LabelName: "制单时间",
              ControlValue: "",
              PlaceHolder: "年/月/日",
              no_arrow: true
            }
          ]
        }
      },

      formDataConfig: {
        HeaderColumns: [],
        DataConfig: {},
        DataList: [
          {
            topL: "1.[会员营销抽奖单]白金",
            topR: "1个",
            bottomL: "2019-06-30 00:12:11",
            bottomR: "处理完毕",
            action: "go_details"
          },
          {
            topL: "2.[会员营销抽奖单]白金",
            topR: "1个",
            bottomL: "2019-06-30 00:12:11",
            bottomR: "处理完毕",
            action: "go_details"
          }
        ]
      },
      paging: {
        cur_page_size: 10,
        cur_page_idx: 1,
        page_count: 0
      },
      Loading: false
    };
  },

  async created() {
    await this.initForm(this.paging.cur_page_idx, this.paging.cur_page_size);
    // this.getUserList(
    //   this.listConfig.pageIndex, this.listConfig.pageSize
    // );
    window.addEventListener("scroll", this.scroll, false); // 监听（绑定）滚轮滚动事件
  },
  methods: {
    scroll() {
      var that = this;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //已滚动底部
        that.information_Load();
      }
    },
    GoQuery(data) {
      this.sliderConfig.isShow = false;
      this.postData = data;
      this.paging = {
        cur_page_size: 10,
        cur_page_idx: 1,
        page_count: 0
      };
      this.getIndexPaged(this.paging.cur_page_idx, this.paging.cur_page_size);
    },
    go_search(INPUT) {
      //this.GET_LIST(INPUT)
      console.log(INPUT, "sss");
      this.sliderConfig.formConfig.list[0].LabelName;
      var postData = {};
      postData[this.sliderConfig.formConfig.list[0].LabelName] = INPUT;
      this.postData = postData;
      this.paging = {
        cur_page_size: 10,
        cur_page_idx: 1,
        page_count: 0
      };
      this.getIndexPaged(this.paging.cur_page_idx, this.paging.cur_page_size);
    },
    information_Load() {
      console.log("底部");
      if (!this.Loading) {
        if (this.paging.cur_page_idx < this.paging.page_count + 1) {
          this.getIndexPaged(
            this.paging.cur_page_idx,
            this.paging.cur_page_size
          );
        } else {
          this.$msg.succ("数据已全部加载");
        }
      }
    },
    async getIndexPaged(index, size) {
      this.$msg.showLoading("正在获取详细信息...");
      var url = this.config.api+this.config.searchName;
      this.postData.PageIndex = index;
      this.postData.PageSize = size;
      this.Loading = true;
      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: this.postData
      });
      this.Loading = false;
      this.$msg.hideLoading();
      this.paging.page_count = result.data.Page.PageCount;

      if (index == 1) {
        this.paging.cur_page_idx++;
        this.formDataConfig.DataList = result.data.Rows;
      } else if (index > 1) {
        this.paging.cur_page_idx++;
        this.formDataConfig.DataList = this.formDataConfig.DataList.concat(
          result.data.Rows
        );
      }
    },
    async initForm(index, size) {
      this.isFormInit = false;
      this.$msg.showLoading("正在获取详细信息...");
      var url = this.config.api+this.config.listName;
      this.postData.PageIndex = index;
      this.postData.PageSize = size;
      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: this.postData
      });
      this.$msg.hideLoading();
      if (result.state == 1) {
        console.log(result, "成功数据");
        this.formItem = result.data;
        this.isFormInit = true;
        this.$msg.succ("加载完成");

        this.paging.page_count =
          result.data.QueryResultTable.DataSource.Page.PageCount;
        this.paging.cur_page_idx++;
        this.sliderConfig.formConfig.list =
          result.data.QueryCondition.ControlsList[0];
        this.search_info.text =
          "请输入" + result.data.QueryCondition.ControlsList[0][0].LabelName;
        var resultTable = result.data.QueryResultTable;
        if (resultTable.DataSource) {
          var dataSource = resultTable.DataSource;
          this.formDataConfig.HeaderColumns = resultTable.HeaderColumns;
          this.formDataConfig.DataList = dataSource.Rows.map(m => {
            return m;
          });
        }

        return;
      }
      this.$msg.alert(result.msg);
      console.log(result);
    },

    onOrderDetailClick(dataItem, index) {
      console.log("onOrderDetailClick", dataItem);
      var url = this.config.detailUrl+"?openId="+dataItem.OpenId;
      this.$router.push({ path: url });
    }
    // getUserList (pageIndex, pageSize) {
    //   this.$msg.loading()
    //   this.$http({
    //     url: this.$api.MemberReferenceList,
    //     method: 'post',
    //     data: { PageIndex: pageIndex, PageSize: pageSize }
    //   }).then(res => {
    //     this.$msg.hideLoading()
    //     if (res.data.state == 1) {
    //       this.userList = res.data.data.list.map((item,index) => {
    //         return {
    //           topL: index+1+'.'+item.Name, topR: item.CurrentPoints+'分',
    //           bottomL: item.Mobile, bottomR: item.CreateOn, avatar: item.HeadImgUrl,
    //           link: `http://ysl.entfly.com/mSms/Member/Detail?openId=${item.OpenId}`
    //         }
    //       })
    //     }
    //   })
    // }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scroll); //  离开页面清除（移除）滚轮滚动事件
  }
};
